<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;" v-if="currUserId == '1'"">
                    <div style="width:160px;">
                        <el-input v-model="form.deptName" placeholder="学校名称"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.username" placeholder="操作人"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.operation" placeholder="操作类型"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-date-picker
                            v-model="form.startDate"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 150px;"
                            type="date"
                            placeholder="操作开始日期">
                        </el-date-picker>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-date-picker
                            v-model="form.endDate"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 150px;"
                            type="date"
                            placeholder="操作结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  @click="exportExcel">导出Excel</el-button>
                    <el-button type="primary" class="handle-del mr10" v-if="currUserId == '1'" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
                </div>
            </div>

            <el-table :data="data" style="width: 100%;margin-bottom: 20px;" row-key="id" height="550" border
                default-expand-all @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="deptName" label="学校名称" :show-overflow-tooltip="true" width="150">
                </el-table-column>
                <el-table-column prop="username" label="操作人" width="150">
                </el-table-column>
                <el-table-column prop="operation" label="操作类型" width="150">
                </el-table-column>
                <el-table-column prop="ip" label="IP地址" width="150">
                </el-table-column>
                <el-table-column prop="time" label="响应时间(毫秒)" width="150">
                </el-table-column>
                <el-table-column prop="method" label="请求方法" :show-overflow-tooltip="true" width="250">
                </el-table-column>
                <el-table-column prop="params" label="请求参数" :show-overflow-tooltip="true" width="250">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="操作时间" :show-overflow-tooltip="true" width="150">
                </el-table-column>
                <el-table-column fixed="right" label="操作" v-if="currUserId == '1'">
                    <template slot-scope="scope">
                        <el-button style="color: red" :disabled="scope.row.roleId == 1"
                            @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="common.page" :page-size="common.pageSize" :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper" :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../../../common/http'
import axios from 'axios'

export default {
    name: "Log",
    data() {
        return {
            menuName:"",
            currUserId:"",
            common: {
                total: 0,            //总数据量
                pageSize: 30,        //每页条数
                page: 1,              //页码
                isPage: 1,            //是否分页
                allSizes: [30, 50, 100], //每页条数筛选
                checkboxArr: []       //多选框数组
            },
            form: {
                id: "",
                username: "",
                operation: "",
                deptName: "",
                startDate: "",
                endDate: "",
            },
            data: []
        }
    },
    created: function () {
        this.menuName = sessionStorage.getItem("selectMenuItem_key")
        //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
        this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id

        this.getData();
    },
    methods: {
        indexMethod(index) {
            return (this.common.page - 1) * this.common.pageSize + (index + 1);
        },
        exportExcel(){
            const maxCount = 65535
            if(this.common.total > maxCount){
                let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                this.$commonFn.showTip(msg,3)
            }else{
                this.exportData()
            }
        },
        exportData(){
            this.loading=true;
            this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待"

            let url=this.logExcelExportUrl
            let param = new URLSearchParams()
            
            param.append('username', this.form.username)
            param.append('operation', this.form.operation)
            param.append('deptName', this.form.deptName)
            param.append('startDate', this.form.startDate)
            param.append('endDate', this.form.endDate)
            
            axios({
                method: "post",
                url: url,
                data: param,
                responseType: "blob"
            }).then(res => {
                const link = document.createElement("a");
                let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", '操作日志.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.loading=false;
            }).catch(error => {
                console.log(error); 
                this.loading=false;
            });
        },
        getData() {
            let url = this.logUrl;
            let data = {
                isPage: this.common.isPage,
                page: this.common.page,
                limit: this.common.pageSize,
                username: this.form.username,
                operation: this.form.operation,
                deptName: this.form.deptName,
                startDate: this.form.startDate,
                endDate: this.form.endDate
            };

            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.data = res.data.logs;
                    this.common.total = res.data.total;
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {

            });
        },
        handleSizeChange(val) {
            this.common.pageSize = val;
            this.common.page = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.common.page = val;
            this.getData();
        },
        //删除
        del(data) {
            this.form.id = data.id;
            this.$commonFn.showConfirm(this.delSuccess);
        },
        delSuccess() {
            let url = this.logDelUrl;
            let data = {
                id: this.form.id
            };
            this.apiPost(url, data).then((res) => {
                if (res.status === 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.common.page = 1;
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            })
        },
        //批量删除管理员
        batchDelete() {
            if (this.common.checkboxArr.length != 0) {
                let checkIdArr = new Array();
                for (var i = 0; i < this.common.checkboxArr.length; i++) {
                    if (this.common.checkboxArr[i] != 1) {
                        checkIdArr.push(this.common.checkboxArr[i]);
                    }
                }
                let idStr = checkIdArr.join(",");
                this.form.id = idStr;
                this.$commonFn.showConfirm(this.delSuccess);
            }
            else {
                this.$commonFn.showTip("请选择删除数据", 2);
            }
        },
        handleSelectionChange(val) {
            this.common.checkboxArr = [];
            for (let i = 0; i < val.length; i++) {
                this.common.checkboxArr.push(val[i].id);
            }
        }
    },
    mixins: [http]
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/sys/log/Log.vue